<!--
 * @Author: scg
 * @Date: 2021-12-10 14:54:44
 * @LastEditTime: 2022-03-03 18:30:00
 * @LastEditors: scg
 * @Description:
-->
<template>
  <div class="fff">
    <div class="page_title">{{$t('and.congratulations')}}</div>
    <div class="Take">
      {{$t('and.take1')}}
    </div>
    <div class="Take">
      {{$t('and.take2')}}
      <a href="https://my.spylix.com">my.spylix.com</a>.
    </div>
    <div @click="gonew()" class="loginButton">{{$t('and.finish')}}</div>
  </div>
</template>

<script>
import { BinddeviceBindDevice } from '@/api/user'
export default {
  inject: ['getheader'],
  name: 'HelloWorld',
  data () {
    return {
      msg: ''
    }
  },
  mounted () {
    console.log(this.key)
  },
  methods: {
    gonew () {
      let key = {
        equipment_id: localStorage.getItem('systemId'),
        type: localStorage.getItem('system') === 'iOS' ? 2 : 1
      }
      console.log(key)
      BinddeviceBindDevice(key).then((adj) => {
        if (adj.code !== 1) {
          this.$message(adj.msg)
          return
        }
        this.getheader()
        this.$router.push({ name: 'index' })
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fff {
  width: 100%;
  position: absolute;
  height: 100%;
  background: #fff;
  overflow: hidden;
}
.Take {
  font-size: 15px;
  color: #45484d;
  line-height: 24px;
  color: grey;
  line-height: 20px;
  margin-left: 5%;
  width: 85%;
  max-width: 800px;
  margin-bottom: 30px;
}
.Take a {
  font-size: 15px;
  color: #0080ff;
}
.loginButton {
  margin-left: 5%;
  width: 280px;
  height: 44px;
  line-height: 44px;
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/And.vue